import { useCallback, useSyncExternalStore } from "react";

/** `matchMedia` reactivo. Sin `matchMedia` (entornos sin layout) devuelve `fallback`. */
export function useMediaQuery(query: string, fallback: boolean): boolean {
  const subscribe = useCallback(
    (onChange: () => void) => {
      if (typeof window.matchMedia !== "function") return () => undefined;
      const list = window.matchMedia(query);
      list.addEventListener("change", onChange);
      return () => list.removeEventListener("change", onChange);
    },
    [query],
  );
  const snapshot = useCallback(() => (typeof window.matchMedia === "function" ? window.matchMedia(query).matches : fallback), [query, fallback]);
  return useSyncExternalStore(subscribe, snapshot, () => fallback);
}
